import { checkIsDisableQuizzSubDomains, isEnableQuizzProducts } from "../../vue/helpers/domain-config";

AFRAME.registerComponent("main-menu-container", {
  schema: {
    userIsInVR: { type: "boolean" },
  },

  update: async function () {
    const quizIsEnabled = !checkIsDisableQuizzSubDomains() || isEnableQuizzProducts()
    if ((!this.data.userIsInVR && quizIsEnabled)) {
      this.setDefaultMenuEnabled(false);
      this.setQuizEnabled(true);
    } else {
      this.setDefaultMenuEnabled(true);
      this.setQuizEnabled(false);
    }
  },

  setDefaultMenuEnabled(enabled) {
    this.el
      .querySelector(".disable-quizz-main-menu-center-bg")
      .setAttribute("visible", enabled);
  },

  setQuizEnabled(enabled) {
    this.el
      .querySelector(".main-menu-center-button-quiz")
      .setAttribute("scale", enabled ? "1 1 1" : "0 0 0");
    this.el
      .querySelector(".main-menu-center-bg")
      .setAttribute("visible", enabled);
  },
});
